import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { SearchParams } from "../user/user";
import { KEYS } from "../localstorage/localstorage";

export class SavedSearchParams {
  name: string;
  searchParams: SearchParams;
}

@Injectable()
export class SearchParamsProvider {
  private SEARCH_PARAMS_KEY: string = "pv-search-params";
  private searchParams: SearchParams;
  private savedSearchParamsList: SavedSearchParams[];

  constructor(public storage: Storage) {}

  initialParams(): SearchParams {
    this.searchParams = <SearchParams>{
      recent_register: false,
      age: { min_range: undefined, max_range: undefined },
      residence_location: [],
      body_type: [],
      business_type: [],
      lookses: [],
      personality: [],
      purpose: [],
      last_login_time: [], // online, in_day, in_week
      income_type: [],
      height: { min_range: undefined, max_range: undefined },
      before_meeting: [],
      education_type: [],
      hometown: [],
      drinking_type: [],
      cigarette_type: [],
      holiday_type: [],
      asset_proved: undefined,
      income_proved: undefined,
      top_photo: "",
      sub_photos: "",
      // bust_type: [],
      self_introduction: "",
      is_royal_option: undefined,
      future_dream: false,
      register_reason: [],
      question_existence: undefined,
      video: undefined,
    };
    return this.searchParams;
  }

  resetParams(): SearchParams {
    return {
      recent_register: false,
      age: { min_range: undefined, max_range: undefined },
      residence_location: [],
      body_type: [],
      business_type: [],
      lookses: [],
      personality: [],
      purpose: [],
      last_login_time: [], // online, in_day, in_week
      income_type: [],
      height: { min_range: undefined, max_range: undefined },
      before_meeting: [],
      education_type: [],
      hometown: [],
      drinking_type: [],
      cigarette_type: [],
      holiday_type: [],
      asset_proved: undefined,
      income_proved: undefined,
      top_photo: "",
      sub_photos: "",
      // bust_type: [],
      self_introduction: "",
      is_royal_option: undefined,
      future_dream: false,
      register_reason: [],
      question_existence: undefined,
      video: undefined,
    };
  }

  async get(): Promise<SearchParams> {
    if (this.searchParams) {
      if (!this.searchParams.lookses) {
        this.searchParams.lookses = [];
      }
      if (!this.searchParams.self_introduction) {
        this.searchParams.self_introduction = "";
      }
      return this.searchParams;
    }
    this.searchParams = await this.storage.get(this.SEARCH_PARAMS_KEY);
    return this.searchParams;
  }

  set(params: SearchParams): Promise<any> {
    this.searchParams = params;
    return this.storage.set(this.SEARCH_PARAMS_KEY, params);
  }

  async setParam(paramId: string, value: any): Promise<any> {
    const params: SearchParams = await this.get();
    params[paramId] = value;
    this.searchParams = params;
    return this.set(params);
  }

  hide(hideParamIds: string[]): Promise<any> {
    Object.keys(this.searchParams).forEach((searchParamName: string) => {
      if (hideParamIds.indexOf(searchParamName) >= 0) {
        this.searchParams[searchParamName] = [];
      }
    });
    return this.set(this.searchParams);
  }

  clear(): Promise<any> {
    this.searchParams = this.initialParams();
    return this.set(this.searchParams);
  }

  buildSwipeParams(): SearchParams {
    let swipeParams: SearchParams = new SearchParams();
    swipeParams.recent_register = false;
    swipeParams.future_dream = false;
    swipeParams.age = {};
    swipeParams.body_type = [];
    swipeParams.business_type = [];
    swipeParams.purpose = [];
    swipeParams.last_login_time = [];
    swipeParams.income_type = [];
    swipeParams.height = {};
    swipeParams.before_meeting = [];
    swipeParams.education_type = [];
    swipeParams.hometown = [];
    swipeParams.drinking_type = [];
    swipeParams.cigarette_type = [];
    swipeParams.asset_proved = undefined;
    swipeParams.income_proved = undefined;
    swipeParams.top_photo = "";
    swipeParams.sub_photos = "";
    // swipeParams.bust_type = [];
    swipeParams.self_introduction = "";
    swipeParams.is_royal_option = undefined;
    swipeParams.question_existence = undefined;
    swipeParams.video = undefined;
    return swipeParams;
  }

  setSavedSearchParamsList(list: SavedSearchParams[]): Promise<any> {
    this.savedSearchParamsList = list;
    return this.storage.set(KEYS.SearchParamsList, this.savedSearchParamsList);
  }

  async getSavedSearchParamsList(): Promise<SavedSearchParams[]> {
    if (this.savedSearchParamsList) {
      return this.savedSearchParamsList;
    }
    this.savedSearchParamsList = await this.storage.get(KEYS.SearchParamsList);
    return this.savedSearchParamsList;
  }

  async addSavedSearchParams(params: SavedSearchParams): Promise<any> {
    let list: SavedSearchParams[] = await this.getSavedSearchParamsList();
    list.push(params);
    return this.setSavedSearchParamsList(list);
  }

  async removeSavedSearchParams(params: SavedSearchParams): Promise<any> {
    let list: SavedSearchParams[] = await this.getSavedSearchParamsList();
    list.splice(list.indexOf(params), 1);
    return this.setSavedSearchParamsList(list);
  }
}



// WEBPACK FOOTER //
// ./src/providers/search-params/search-params.ts